import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import ProductLaunchForm from "../../../../components/custom/merchandise/launch/ProductLaunchForm";
import withMediaQuery from "../../../../hocs/withMediaQuery";

const NewLaunch = ({ mediaQuery }) => {
  const { t } = useTranslation(["merchandising"]);
  return (
    <div>
      <h2
        style={{
          fontSize: "26px",
          color: "#403E3D",
          fontWeight: "700",
          margin: "5rem auto 3rem",
          padding: "1rem auto",
          marginLeft: mediaQuery ? "2rem" : "390px",
        }}
      >
        {t(($) => $.merchandising["New Product Launch"])}
      </h2>

      <ProductLaunchForm />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/user/productlaunch/new")({
  component: withMediaQuery("(max-width:600px)")(NewLaunch),
});
